import React from "react";

type Props = {
  date: Date;
  showDate?: boolean;
  showTime?: boolean;
};

export const Timestamp: React.FC<Props> = ({ date, showDate, showTime }) => (
  <time>
    {showDate && date.toLocaleDateString()} {showTime && date.toLocaleTimeString()}
  </time>
);
